import './MCPLayoutStyle.scss';

import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { menu as menuConstants, state as stateConstants } from 'src/constants';
import { FetchData } from 'src/core/components';
import { getList, remove } from 'src/core/redux/actions';
import { selectListData, selectListFetchData } from 'src/core/redux/selectors';
import { DesignType } from 'src/models';

import { getMenuGroups } from './helper';
import MCPLayoutComponent from './MCPLayoutComponent';
import { selectSataticMenuItems } from './selectors';

const MCPLayoutContainer = ({
  fetchData,
  designTypes,
  fetchDataProps,
  resetData,
  staticMenuItems,
}) => {
  const [selectedMenuItem, setSelectedMenuItem] = useState({
    searchText: '',
    category: {
      name: menuConstants.VIEW_ALL,
      categoryNr: '',
    },
    subcategory: {
      name: '',
      subcategoryNr: '',
    },
  });
  const [searchFormData, setSearchFormData] = useState({
    searchText: selectedMenuItem?.searchText,
    category: 'viewAll',
    categoryNr: '',
    label: 'View All',
    subcategoryNr: '',
  });
  const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);
  const [radioSelected, setRadioSelected] = useState('');
  const [filterFormData, setFilterFormData] = useState({
    dateRange: '',
    status: '',
    startDate: '',
    endDate: '',
  });

  const isViewAllActive =
    selectedMenuItem.category.name === menuConstants.VIEW_ALL;

  return (
    <FetchData
      whenToFetch={isViewAllActive}
      fetchData={fetchData}
      resetData={resetData}
      payload={selectedMenuItem}
      {...fetchDataProps}
    >
      <MCPLayoutComponent
        {...{
          isViewAllActive,
          selectedMenuItem,
          setSelectedMenuItem,
          menuGroups: getMenuGroups(designTypes),
          overviewData: designTypes,
          staticMenuItems,
          searchFormData,
          setSearchFormData,
          showAdvanceSearch,
          setShowAdvanceSearch,
          radioSelected,
          setRadioSelected,
          filterFormData,
          setFilterFormData,
        }}
      />
    </FetchData>
  );
};

MCPLayoutContainer.propTypes = {
  designTypes: PropTypes.array,
  fetchDataProps: PropTypes.object,
  staticMenuItems: PropTypes.array,
  fetchData: PropTypes.func,
  resetData: PropTypes.func,
};

const mapStateToProps = (state) => ({
  designTypes: selectListData(DesignType)(state)?.list,
  fetchDataProps: selectListFetchData(DesignType)(state),
  staticMenuItems: selectSataticMenuItems(state),
});

const mapDispatchToProps = {
  fetchData: getList(DesignType),
  resetData: remove(DesignType.NAME, stateConstants.IDENTIFIER_TYPE_LIST),
};

export default connect(mapStateToProps, mapDispatchToProps)(MCPLayoutContainer);
